import React, { useEffect, useState } from "react";
import InnerHeader from "../../component/shared/innerheader/InnerHeader.js";
// import SliderVersion from "../../component/shared/sliderVersion/SliderVersion.js";
import "./Versions.scss";
import ChevronIcon from "svg-icons/chevron-icon.js";
import { useSelector } from "react-redux";
import { FormattedMessage, useIntl } from "react-intl";
import { useParams } from "react-router";
import { END_POINTS } from "constants/APIConstant.js";
import LabelLang, { LabelLangString } from "component/LabelLang/label-lang.js";
import useSWR from "swr";
import ContentLoading from "component/LoadingComponent/ContentLoading.js";
import HtmlView from "component/htmlView/html-view.js";
import { API_BASE_URL } from "configs/AppConfig.js";
import { saveAs } from "file-saver";
//import FontAwesomeIcon from 'react-fontawesome'
import { DateFormater } from "functions/dateTimeFormat.js";
import DataNotFound from "component/shared/DataNotFound/DataNotFound.jsx";
import { Link } from "react-router-dom";
import FilesModal from "./filesModal/index.jsx";
import { GetStudyPeriod } from "functions/getStudyPeriod.js";
import getYearName from "functions/getYearName.js";
import {
  FacebookShare,
  LinkedinShare,
  TwitterShare,
} from "component/SocialMediaComponent/SocialMediaComponent.jsx";
import ReactGA from "react-ga4";
import { MutateCacheSWRPartialKey } from "services/SWRPartialKeyService.js";

function Versions() {
  let intl = useIntl();

  const dir = useSelector(({ theme }) => theme.direction);

  const currentLocale = useSelector(({ theme }) => theme.locale);

  const [preparingPDFFile, setPreparingPDFFile] = useState(false);
  const [preparingExcelFile, setPreparingExcelFile] = useState(false);

  const { id } = useParams();

  const [showPdfFiles, setShowPdfFiles] = useState(false);
  const handleClosePdfFiles = () => setShowPdfFiles(false);
  const handleShowPdfFiles = () => {
    setShowPdfFiles(true);
  };

  const [showExcelFiles, setShowExcelFiles] = React.useState(false);
  const handleCloseExcelFiles = () => setShowExcelFiles(false);
  const handleShowExcelFiles = () => {
    setShowExcelFiles(true);
  };

  const dataFetching = useSWR({
    url: `${END_POINTS.PUBLICATION_DETAILS}/${id}`,
  });

  ReactGA.initialize(END_POINTS.TRACKING_ID);

  useEffect(() => {
    // Send pageview with a custom path
    ReactGA.send({
      hitType: "pageview",
      page: `/publications/${id}`,
      title: `Publication: ${dataFetching.data?.data?.name}-${dataFetching.data?.data?.publicationDetail?.year}`,
    });
  }, [id]);

  const onExport = async (fileType, url, publicationName) => {
    fileType === "PDF"
      ? setPreparingPDFFile(true)
      : setPreparingExcelFile(true);
    var result = await fetch(
      `${API_BASE_URL}/api/MediaUploader/download?url=${url}&fileName=${publicationName}`
    ).then((response) => {
      response.blob().then((blob) => {
        saveAs(blob, publicationName);
        // console.log("Response: ", response);
        // // Creating new object of PDF file

        // let file = new Blob([response], { type: "application/pdf" });
        // const fileURL = window.URL.createObjectURL(file);

        // // Setting various property values
        // let alink = document.createElement("a");
        // alink.href = fileURL;
        // alink.download = publicationName;
        // alink.click();
      });
    });

    ReactGA.event({
      category: "Download",
      action: "Download Publication",
      label: `${publicationName}`,
    });
    setPreparingPDFFile(false);
    setPreparingExcelFile(false);
  };

  const [selectYear, setSelectYear] = React.useState(
    dataFetching?.data?.data?.publicationDetail?.year
  );
  const [selectMonth, setSelectMonth] = React.useState(
    dataFetching?.data?.data?.publicationDetail?.month
  );
  const [selectQuarter, setSelectQuarter] = React.useState(
    dataFetching?.data?.data?.publicationDetail?.quarter
  );

  const relatedDataFetching = useSWR({
    url: `${END_POINTS.RELATED_PUBLICATION_DETAILS}=${id}`,
  });

  const periodsFetching = useSWR({
    url: `${END_POINTS.PUBLICATION_PERIODS}=${id}`,
  });

  const [currentYearMonthIds, setCurrentYearMonthIds] = useState(
    periodsFetching.error ||
      periodsFetching.isLoading ||
      periodsFetching.data === undefined ||
      !periodsFetching.data.data
      ? []
      : [
          ...periodsFetching.data.data
            .filter(
              (x) =>
                x.year === +dataFetching?.data?.data?.publicationDetail?.year
            )
            .map((el) => {
              const rendering = [el.month];
              return rendering;
            }),
        ].flat()
  );

  const [currentYearQuarterIds, setCurrentYearQuarterIds] = useState(
    periodsFetching.error ||
      periodsFetching.isLoading ||
      periodsFetching.data === undefined ||
      !periodsFetching.data.data
      ? []
      : [
          ...periodsFetching.data.data
            .filter(
              (x) =>
                x.year === +dataFetching?.data?.data?.publicationDetail?.year
            )
            .map((el) => {
              const rendering = [el.quarter];
              return rendering;
            }),
        ].flat()
  );

  const allMonths = [
    {
      name: "يناير",
      value: 1,
      translation: [{ name: "January", locale: "en" }],
    },
    {
      name: "فبراير",
      value: 2,
      translation: [{ name: "February", locale: "en" }],
    },
    {
      name: "مارس",
      value: 3,
      translation: [{ name: "March", locale: "en" }],
    },
    {
      name: "إبريل",
      value: 4,
      translation: [{ name: "April", locale: "en" }],
    },
    {
      name: "مايو",
      value: 5,
      translation: [{ name: "May", locale: "en" }],
    },
    {
      name: "يونيه",
      value: 6,
      translation: [{ name: "June", locale: "en" }],
    },
    {
      name: "يوليو",
      value: 7,
      translation: [{ name: "July", locale: "en" }],
    },
    {
      name: "اغسطس",
      value: 8,
      translation: [{ name: "August", locale: "en" }],
    },
    {
      name: "سبتمبر",
      value: 9,
      translation: [{ name: "September", locale: "en" }],
    },
    {
      name: "اكتوبر",
      value: 10,
      translation: [{ name: "October", locale: "en" }],
    },
    {
      name: "نوفمبر",
      value: 11,
      translation: [{ name: "November", locale: "en" }],
    },
    {
      name: "ديسمبر",
      value: 12,
      translation: [{ name: "December", locale: "en" }],
    },
  ];

  const [renderedMonths, setRenderedMonths] = useState(
    allMonths.filter((item) => currentYearMonthIds.includes(item.value))
  );

  const allQuarters = [
    {
      name: "الربع الأول",
      value: 1,
      translation: [{ name: "First Quarter", locale: "en" }],
    },
    {
      name: "الربع الثاني",
      value: 2,
      translation: [{ name: "Second Quarter", locale: "en" }],
    },
    {
      name: "الربع الثالث",
      value: 3,
      translation: [{ name: "Third Quarter", locale: "en" }],
    },
    {
      name: "الربع الرابع",
      value: 4,
      translation: [{ name: "Fourth Quarter", locale: "en" }],
    },
  ];

  const [renderedQuarters, setRenderedQuarters] = useState(
    allQuarters.filter((item) => currentYearQuarterIds.includes(item.value))
  );

  const allHalfs = [
    {
      name: "النصف الأول",
      value: 2,
      translation: [{ name: "First Half", locale: "en" }],
    },
    {
      name: "النصف الثاني",
      value: 4,
      translation: [{ name: "Second Half", locale: "en" }],
    },
  ];

  const [renderedHalfs, setRenderedHalfs] = useState(
    allHalfs.filter((item) => currentYearQuarterIds.includes(item.value))
  );

  const renderYears =
    periodsFetching.error ||
    periodsFetching.isLoading ||
    periodsFetching.data === undefined ||
    !periodsFetching.data.data
      ? []
      : [
          ...periodsFetching.data.data.map((el) => {
            const rendering = [el.year];
            return rendering;
          }),
        ].flat();

  const uniqueRenderYears = [...new Set(renderYears)];

  const searchPublicationDetailsFetching = useSWR({
    url: `${END_POINTS.SEARCH_PUBLICATION_DETAILS}=${id}${
      selectYear !== null && selectYear !== undefined
        ? // && uniqueRenderYears.includes(+selectYear)
          `&Year=${selectYear}`
        : ""
    }${
      selectMonth !== null &&
      selectMonth !== undefined &&
      selectMonth !== -1 &&
      currentYearMonthIds.length > 0
        ? `&Month=${selectMonth}`
        : ""
    }${
      selectQuarter !== null &&
      selectQuarter !== undefined &&
      selectQuarter !== -1 &&
      currentYearQuarterIds.length > 0
        ? `&Quarter=${selectQuarter}`
        : ""
    }`,
  });

  const renderSearchDetails = () => {
    const renderSearch =
      searchPublicationDetailsFetching.error ||
      searchPublicationDetailsFetching.isLoading ||
      searchPublicationDetailsFetching.data === undefined ||
      searchPublicationDetailsFetching.data === null ||
      !searchPublicationDetailsFetching.data.data
        ? []
        : { ...searchPublicationDetailsFetching?.data?.data };

    const rendering = {
      excelUrl: renderSearch?.excelUrl,
      id: renderSearch?.id,
      // infographics: renderSearch?.infographics,
      month: renderSearch?.month,
      pdfUrl: renderSearch?.pdfUrl,
      publicationCover: renderSearch?.publicationCover,
      publishDate: renderSearch?.publishDate,
      quarter: renderSearch?.quarter,
      releaseDate: renderSearch?.releaseDate,
      studyPeriod: renderSearch?.studyPeriodAsString,
      year: renderSearch?.year,
      publicationDetailsFiles: renderSearch?.publicationDetailsFiles,
      pdfFiles: renderSearch?.publicationDetailsFiles?.filter(
        (el) => el.fileType === 2
      ),
      excelFiles: renderSearch?.publicationDetailsFiles?.filter(
        (el) => el.fileType === 1
      ),
    };

    return rendering;
  };

  useEffect(() => {
    setSelectYear(dataFetching?.data?.data?.publicationDetail?.year);
    setSelectMonth(dataFetching?.data?.data?.publicationDetail?.month);
    setSelectQuarter(dataFetching?.data?.data?.publicationDetail?.quarter);
  }, [id, dataFetching?.data?.data]);

  useEffect(() => {
    const timeOut = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
    currentYearMonthIds.length > 0 &&
      setRenderedMonths(
        allMonths.filter((item) => currentYearMonthIds.includes(item.value))
      );
    currentYearQuarterIds.length > 0 &&
      setRenderedQuarters(
        allQuarters.filter((item) => currentYearQuarterIds.includes(item.value))
      );
    currentYearQuarterIds.length > 0 &&
      setRenderedHalfs(
        allHalfs.filter((item) => currentYearQuarterIds.includes(item.value))
      );
    return () => {
      clearTimeout(timeOut);
    };
  }, [
    id,
    selectYear,
    selectMonth,
    selectQuarter,
    currentYearMonthIds,
    currentYearQuarterIds,
  ]);

  useEffect(() => {
    setCurrentYearMonthIds(
      periodsFetching.error ||
        periodsFetching.isLoading ||
        periodsFetching.data === undefined ||
        !periodsFetching.data.data
        ? []
        : [
            ...periodsFetching.data.data
              .filter((x) => x.year === +selectYear)
              .map((el) => {
                const rendering = [el.month];
                return rendering;
              }),
          ].flat()
    );
    setSelectMonth(dataFetching?.data?.data?.publicationDetail?.month);

    setCurrentYearQuarterIds(
      periodsFetching.error ||
        periodsFetching.isLoading ||
        periodsFetching.data === undefined ||
        !periodsFetching.data.data
        ? []
        : [
            ...periodsFetching.data.data
              .filter((x) => x.year === +selectYear)
              .map((el) => {
                const rendering = [el.quarter];
                return rendering;
              }),
          ].flat()
    );
    setSelectQuarter(dataFetching?.data?.data?.publicationDetail?.quarter);
  }, [selectYear, dataFetching?.data?.data]);

  return (
    <ContentLoading
      isLoading={
        // dataFetching.error ||
        dataFetching.isLoading ||
        // relatedDataFetching.error ||
        relatedDataFetching.isLoading ||
        // periodsFetching.error ||
        periodsFetching.isLoading
      }
    >
      <InnerHeader
        breadcrumb={[
          {
            title: <FormattedMessage id="publications" />,
            clickClass: false,
          },
          {
            title:
              dataFetching?.data?.data?.name !== null &&
              dataFetching?.data?.data?.name !== undefined ? (
                <LabelLang
                  id="name"
                  defaultValue={dataFetching?.data?.data?.name}
                  translations={
                    dataFetching?.data?.data?.publicationTranslations
                  }
                />
              ) : (
                <FormattedMessage id="data-not-found" />
              ),
            clickClass: true,
          },
        ]}
        title={<FormattedMessage id="browse-publications" />}
        route={"../publications"}
      />

      <div className="media-landing-news-Item">
        <div className="container">
          <div className="row py-4">
            <div className="col-12 col-lg-9">
              <div className="row mb-4">
                <div className="col-12 col-lg-8">
                  <div className="item-news-s">
                    <h2>
                      {dataFetching?.data?.data?.name !== null &&
                      dataFetching?.data?.data?.name !== undefined ? (
                        <LabelLang
                          id="name"
                          defaultValue={dataFetching?.data?.data?.name}
                          translations={
                            dataFetching?.data?.data?.publicationTranslations
                          }
                        />
                      ) : (
                        <FormattedMessage id="data-not-found" />
                      )}
                    </h2>
                    <p>
                      {dataFetching?.data?.data?.description !== null &&
                      dataFetching?.data?.data?.description !== undefined ? (
                        <HtmlView
                          html={LabelLangString({
                            id: "description",
                            currentLocale: currentLocale,
                            defaultValue: dataFetching?.data?.data?.description,
                            translations:
                              dataFetching?.data?.data?.publicationTranslations,
                          })}
                        />
                      ) : (
                        <FormattedMessage id="data-not-found" />
                      )}
                    </p>
                  </div>
                </div>
                <div className="col-12 col-lg-4 mt-5">
                  <div className="item-book">
                    <img
                      loading="lazy"
                      className="w-100"
                      src={
                        dataFetching?.data?.data?.cover !== null &&
                        dataFetching?.data?.data?.cover !== undefined
                          ? `${API_BASE_URL}/${dataFetching?.data?.data?.cover}`
                          : process.env.PUBLIC_URL + "/image/book.png"
                      }
                      alt="book"
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-12 col-lg-6">
                  {/* render pdf & excel data */}
                  {renderSearchDetails()?.publicationDetailsFiles?.length > 0 ||
                  renderSearchDetails()?.pdfUrl ||
                  renderSearchDetails()?.excelUrl ? (
                    <div className="share-t row align-items-center">
                      <div className="col-lg-4">
                        <h6 className="mb-0">
                          <FormattedMessage id="download-publication" />{" "}
                        </h6>
                      </div>
                      {renderSearchDetails()?.pdfFiles &&
                      renderSearchDetails()?.pdfFiles?.length > 0 ? (
                        <div className="col-lg-1">
                          {preparingPDFFile ? (
                            <img
                              src={`${process.env.PUBLIC_URL}/loading2.gif`}
                              style={{
                                width: 80,
                                height: "auto",
                                //marginTop: 0,
                              }}
                            />
                          ) : (
                            <img
                              loading="lazy"
                              src={process.env.PUBLIC_URL + "/image/pdf.png"}
                              alt="pdf-img"
                              height="40"
                              style={{ cursor: "pointer" }}
                              onClick={handleShowPdfFiles}
                            />
                          )}
                          <FilesModal
                            show={showPdfFiles}
                            handleClose={handleClosePdfFiles}
                            files={renderSearchDetails()?.pdfFiles}
                            type={2}
                            fileUrl={renderSearchDetails()?.pdfUrl}
                            onExport={onExport}
                            studyPeriod={renderSearchDetails()?.studyPeriod}
                            publicationName={LabelLangString({
                              id: "name",
                              currentLocale: currentLocale,
                              defaultValue: dataFetching?.data?.data?.name,
                              translations:
                                dataFetching?.data?.data
                                  ?.publicationTranslations,
                            })}
                          />
                        </div>
                      ) : renderSearchDetails()?.pdfUrl ? (
                        <div className="col-lg-1">
                          {/* <a href={`${API_BASE_URL}${
                              renderSearchDetails()?.pdfUrl
                            }`}
                            target="_blank"
                            rel="noreferrer"
                            title={`${LabelLangString({
                              id: "name",
                              currentLocale: currentLocale,
                              defaultValue: dataFetching?.data?.data?.name,
                              translations:
                                dataFetching?.data?.data
                                  ?.publicationTranslations,
                            })} / ${intl.formatMessage({
                              id: "unnamed-file",
                            })}`}
                          >
                            <img
                              loading="lazy"
                              src={process.env.PUBLIC_URL + "/image/pdf.png"}
                              alt={intl.formatMessage({ id: "unnamed-file" })}
                              height="40"
                            />
                          </a> */}
                          {preparingPDFFile ? (
                            <img
                              src={`${process.env.PUBLIC_URL}/loading2.gif`}
                              style={{
                                width: 80,
                                height: "auto",
                                //marginTop: 0,
                              }}
                            />
                          ) : (
                            <button
                              style={{
                                border: "none",
                                backgroundColor: "transparent",
                              }}
                              onClick={() =>
                                onExport(
                                  "PDF",
                                  `${renderSearchDetails()?.pdfUrl.substring(
                                    1
                                  )}`,
                                  `${LabelLangString({
                                    id: "name",
                                    currentLocale: currentLocale,
                                    defaultValue:
                                      dataFetching?.data?.data?.name,
                                    translations:
                                      dataFetching?.data?.data
                                        ?.publicationTranslations,
                                  })} / ${renderSearchDetails()?.studyPeriod}`
                                )
                              }
                            >
                              <img
                                loading="lazy"
                                src={process.env.PUBLIC_URL + "/image/pdf.png"}
                                alt={intl.formatMessage({ id: "unnamed-file" })}
                                height="40"
                              />
                            </button>
                          )}
                        </div>
                      ) : (
                        ""
                      )}
                      &nbsp;&nbsp;&nbsp;
                      {renderSearchDetails()?.excelFiles &&
                      renderSearchDetails()?.excelFiles?.length > 0 ? (
                        <div className="col-lg-1">
                          <img
                            loading="lazy"
                            src={process.env.PUBLIC_URL + "/image/Excel.svg"}
                            alt="excel-image"
                            height="40"
                            style={{ cursor: "pointer" }}
                            onClick={handleShowExcelFiles}
                          />
                          <FilesModal
                            show={showExcelFiles}
                            handleClose={handleCloseExcelFiles}
                            files={renderSearchDetails()?.excelFiles}
                            type={1}
                            fileUrl={renderSearchDetails()?.excelUrl}
                            onExport={onExport}
                            studyPeriod={renderSearchDetails()?.studyPeriod}
                            publicationName={LabelLangString({
                              id: "name",
                              currentLocale: currentLocale,
                              defaultValue: dataFetching?.data?.data?.name,
                              translations:
                                dataFetching?.data?.data
                                  ?.publicationTranslations,
                            })}
                          />
                        </div>
                      ) : renderSearchDetails()?.excelUrl ? (
                        <div className="col-lg-1">
                          {preparingExcelFile ? (
                            <img
                              src={`${process.env.PUBLIC_URL}/loading2.gif`}
                              style={{
                                width: 80,
                                height: "auto",
                                //marginTop: 0,
                              }}
                            />
                          ) : (
                            <button
                              style={{
                                border: "none",
                                backgroundColor: "transparent",
                              }}
                              onClick={() =>
                                onExport(
                                  "EXCEL",
                                  `${renderSearchDetails()?.excelUrl.substring(
                                    1
                                  )}`,
                                  `${LabelLangString({
                                    id: "name",
                                    currentLocale: currentLocale,
                                    defaultValue:
                                      dataFetching?.data?.data?.name,
                                    translations:
                                      dataFetching?.data?.data
                                        ?.publicationTranslations,
                                  })} / ${renderSearchDetails()?.studyPeriod}`
                                )
                              }
                            >
                              <img
                                loading="lazy"
                                src={
                                  process.env.PUBLIC_URL + "/image/Excel.svg"
                                }
                                alt={intl.formatMessage({ id: "unnamed-file" })}
                                height="40"
                              />
                            </button>
                          )}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  ) : (
                    ""
                  )}

                  <br></br>
                  <div className="share-t row align-items-center">
                    <div className="col-lg-4">
                      <h6 className="mb-0">
                        <FormattedMessage id="share-publication" />
                      </h6>
                    </div>
                    <div className="col-lg-1">
                      <FacebookShare
                        url={`${window.location.href}`}
                        title={dataFetching?.data?.data?.name}
                        //tags={newsDetailsFetching.data.data.tags}
                      >
                        <div className="item-link">
                          <i className="icon fab fa-facebook-f"></i>
                        </div>
                      </FacebookShare>
                    </div>
                    &nbsp;
                    <div className="col-lg-1">
                      <TwitterShare
                        url={`${window.location.href}`}
                        title={dataFetching?.data?.data?.name}
                        //tags={newsDetailsFetching.data.data.tags}
                      >
                        <img
                          className="img1"
                          src={process.env.PUBLIC_URL + "/image/X-small.png"}
                          height={32}
                          width={32}
                          content-item
                          loading="lazy"
                        />
                      </TwitterShare>
                    </div>
                    &nbsp;
                    <div className="col-lg-1">
                      <LinkedinShare
                        url={`${window.location.href}`}
                        title={dataFetching?.data?.data?.name}
                        brief={dataFetching?.data?.data?.description}
                      >
                        <div className="item-link">
                          <a href="">
                            <i className="icon fab fa-linkedin-in"></i>
                          </a>
                        </div>
                      </LinkedinShare>
                    </div>
                  </div>
                </div>
                <div className="col-lg-2"></div>
                <div className="col-lg-4">
                  {dataFetching?.data?.data?.hasData && (
                    <>
                      <Link
                        to={`../../data/mainSubject/${dataFetching?.data?.data?.subject?.mainSubjectId}/subSubject/${dataFetching?.data?.data?.subject?.id}`}
                        className="main-btn mie"
                      >
                        <span>
                          <FormattedMessage id="info-publication" />{" "}
                          <ChevronIcon width={20} height={10} />
                        </span>
                      </Link>
                      <br />
                    </>
                  )}
                  {dataFetching?.data?.data?.hasMetaData && (
                    <>
                      <Link
                        to={LabelLangString({
                          id: "metaDataLink",
                          currentLocale: currentLocale,
                          defaultValue: dataFetching?.data?.data?.metaDataLink,
                          translations:
                            dataFetching?.data?.data?.publicationTranslations,
                        })}
                        className="main-btn"
                      >
                        <span>
                          <FormattedMessage id="metadata" />{" "}
                          <ChevronIcon width={20} height={10} />
                        </span>
                      </Link>
                      <br />
                    </>
                  )}

                  {dataFetching?.data?.data?.hasInfograph && (
                    <Link
                      to={`../../infograph/${renderSearchDetails()?.id}`}
                      className="main-btn"
                    >
                      <span>
                        <FormattedMessage id="infographic" />{" "}
                        <ChevronIcon width={20} height={10} />
                      </span>
                    </Link>
                  )}
                </div>
              </div>

              <br></br>
              <div
                className="box-ver-i"
                style={{ backgroundColor: "#1F254B", color: "#FFF" }}
              >
                <div className="row">
                  <div className="col-lg-2">
                    <h6>
                      <FormattedMessage id="years" />
                    </h6>
                  </div>
                  {/* <div className="col-lg-10" style={{ color: "#808080" }}>
                    {" "}
                    [ {uniqueRenderYears.join(', ')} ]
                  </div> */}
                  <div className="item-form">
                    <select
                      style={{
                        backgroundPosition: dir === "rtl" ? "4%" : "96%",
                      }}
                      defaultValue={
                        dataFetching?.data?.data?.publicationDetail?.year
                      }
                      value={selectYear}
                      onChange={(e) => {
                        setSelectYear(e.target.value);
                        setSelectMonth(-1);
                        setSelectQuarter(-1);
                        setCurrentYearMonthIds(
                          periodsFetching.error ||
                            periodsFetching.isLoading ||
                            periodsFetching.data === undefined ||
                            !periodsFetching.data.data
                            ? []
                            : [
                                ...periodsFetching.data.data
                                  .filter((x) => x.year === +e.target.value)
                                  .map((el) => {
                                    const rendering = [el.month];
                                    return rendering;
                                  }),
                              ].flat()
                        );
                        setCurrentYearQuarterIds(
                          periodsFetching.error ||
                            periodsFetching.isLoading ||
                            periodsFetching.data === undefined ||
                            !periodsFetching.data.data
                            ? []
                            : [
                                ...periodsFetching.data.data
                                  .filter((x) => x.year === +e.target.value)
                                  .map((el) => {
                                    const rendering = [el.quarter];
                                    return rendering;
                                  }),
                              ].flat()
                        );
                      }}
                    >
                      <option>
                        [<FormattedMessage id="choose-year" />]
                      </option>
                      {uniqueRenderYears &&
                        uniqueRenderYears.map((el, i) => (
                          <option
                            key={i}
                            value={+el}
                            defaultChecked={
                              +el ===
                              dataFetching?.data?.data?.publicationDetail?.year
                            }
                          >
                            {getYearName(
                              dataFetching?.data?.data?.yearTypeId,
                              el
                            )}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>
                {+dataFetching?.data?.data?.periodic?.id === 1 ||
                +dataFetching?.data?.data?.periodic?.id === 2 ||
                +dataFetching?.data?.data?.periodic?.id === 9 ||
                +dataFetching?.data?.data?.periodic?.id === 3 ||
                +dataFetching?.data?.data?.periodic?.id === 4 ? (
                  <div className="row">
                    <div className="col-lg-3">
                      <h6>
                        <FormattedMessage id="months/periods" />
                      </h6>
                    </div>
                    <div className="col-lg-9" style={{ color: "#808080" }}>
                      {/* {+dataFetching?.data?.data?.periodic?.id === 1 ||
                      +dataFetching?.data?.data?.periodic?.id === 2 ||
                      +dataFetching?.data?.data?.periodic?.id === 9 ?
                      (
                        <>
                          [ {renderMonths.map(({ name, translation }, i) => (
                            <span key={i}>
                              {LabelLangString({
                                id: "name",
                                currentLocale: currentLocale,
                                defaultValue: name,
                                translations: translation,
                              })}{i === renderMonths.length - 1 ? '' : ', '}
                            </span>
                          ))} ]
                        </>
                      )
                      :
                      +dataFetching?.data?.data?.periodic?.id === 3 ||
                      +dataFetching?.data?.data?.periodic?.id === 4 ?
                      (
                        <>
                          [ {renderQuarters.map(({ name, translation }, i) => (
                            <span key={i}>
                              {LabelLangString({
                                id: "name",
                                currentLocale: currentLocale,
                                defaultValue: name,
                                translations: translation,
                              })}{i === renderQuarters.length - 1 ? '' : ', '}
                            </span>
                          ))} ]
                        </>
                      )
                      :
                      ''
                    } */}
                    </div>
                  </div>
                ) : null}

                {+dataFetching?.data?.data?.periodic?.id === 1 ||
                +dataFetching?.data?.data?.periodic?.id === 2 ||
                +dataFetching?.data?.data?.periodic?.id === 9 ? (
                  <div className="item-form">
                    <select
                      style={{
                        backgroundPosition: dir === "rtl" ? "4%" : "96%",
                      }}
                      defaultValue={
                        dataFetching?.data?.data?.publicationDetail?.month
                      }
                      value={selectMonth}
                      onChange={(e) => {
                        setSelectMonth(e.target.value);
                      }}
                    >
                      <option value={-1}>
                        [<FormattedMessage id="choose-month" />]
                      </option>
                      {renderedMonths.map(({ name, value, translation }, i) => (
                        <option
                          key={i}
                          value={value}
                          defaultChecked={
                            value ===
                            dataFetching?.data?.data?.publicationDetail?.month
                          }
                          title={LabelLangString({
                            id: "name",
                            currentLocale: currentLocale,
                            defaultValue: name,
                            translations: translation,
                          })}
                        >
                          <LabelLang
                            id={"name"}
                            defaultValue={name}
                            translations={translation}
                          />
                        </option>
                      ))}
                    </select>
                  </div>
                ) : null}
                {+dataFetching?.data?.data?.periodic?.id === 3 ? (
                  <div className="item-form">
                    <select
                      style={{
                        backgroundPosition: dir === "rtl" ? "4%" : "96%",
                      }}
                      defaultValue={
                        dataFetching?.data?.data?.publicationDetail?.quarter
                      }
                      value={selectQuarter}
                      onChange={(e) => {
                        setSelectQuarter(e.target.value);
                      }}
                    >
                      <option value={-1}>
                        [<FormattedMessage id="choose-quarter" />]
                      </option>
                      {renderedQuarters.map(
                        ({ name, value, translation }, i) => (
                          <option
                            key={i}
                            value={value}
                            defaultChecked={
                              value ===
                              dataFetching?.data?.data?.publicationDetail
                                ?.quarter
                            }
                            title={LabelLangString({
                              id: "name",
                              currentLocale: currentLocale,
                              defaultValue: name,
                              translations: translation,
                            })}
                          >
                            <LabelLang
                              id={"name"}
                              defaultValue={name}
                              translations={translation}
                            />
                          </option>
                        )
                      )}
                    </select>
                  </div>
                ) : null}
                {+dataFetching?.data?.data?.periodic?.id === 4 ? (
                  <div className="item-form">
                    <select
                      style={{
                        backgroundPosition: dir === "rtl" ? "4%" : "96%",
                      }}
                      defaultValue={
                        dataFetching?.data?.data?.publicationDetail?.quarter
                      }
                      value={selectQuarter}
                      onChange={(e) => {
                        setSelectQuarter(e.target.value);
                      }}
                    >
                      <option value={-1}>
                        [<FormattedMessage id="choose-half" />]
                      </option>
                      {renderedHalfs.map(({ name, value, translation }, i) => (
                        <option
                          key={i}
                          value={value}
                          defaultChecked={
                            value ===
                            dataFetching?.data?.data?.publicationDetail?.half
                          }
                          title={LabelLangString({
                            id: "name",
                            currentLocale: currentLocale,
                            defaultValue: name,
                            translations: translation,
                          })}
                        >
                          <LabelLang
                            id={"name"}
                            defaultValue={name}
                            translations={translation}
                          />
                        </option>
                      ))}
                    </select>
                  </div>
                ) : null}
              </div>

              {/* <div className="infographic">
                <h5>إنفوجرافيك</h5>

                <div className="row">
                  <div className="col-12 col-lg-4">
                    <div className="info-card">
                      <img 
                        loading="lazy"
                        className="w-100"
                        src={process.env.PUBLIC_URL + "/image/info1.png"}
                        alt="info"
                      />
                    </div>
                  </div>
                  <div className="col-12 col-lg-4">
                    <div className="info-card">
                      <img 
                        loading="lazy"
                        className="w-100"
                        src={process.env.PUBLIC_URL + "/image/info2.png"}
                        alt="info"
                      />
                    </div>
                  </div>
                  <div className="col-12 col-lg-4">
                    <div className="info-card">
                      <img 
                        loading="lazy"
                        className="w-100"
                        src={process.env.PUBLIC_URL + "/image/info3.png"}
                        alt="info"
                      />
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
            <div className="col-12 col-lg-3">
              <div className="box-ver">
                <div className="ver-inf">
                  <span>
                    <FormattedMessage id="publication-type" />
                  </span>
                  <span>
                    <LabelLang
                      id="name"
                      defaultValue={
                        dataFetching?.data?.data?.publicationType?.name
                      }
                      translations={
                        dataFetching?.data?.data?.publicationType
                          ?.publicationTypeTranslations
                      }
                    />
                  </span>
                </div>
                <div className="ver-inf">
                  <span>
                    <FormattedMessage id="topic" />
                  </span>
                  <span>
                    <LabelLang
                      id="title"
                      defaultValue={dataFetching?.data?.data?.subject?.title}
                      translations={
                        dataFetching?.data?.data?.subject?.subjectTranslations
                      }
                    />
                  </span>
                </div>
                <div className="ver-inf">
                  <span>
                    <FormattedMessage id="periodical" />
                  </span>
                  <span>
                    <LabelLang
                      id="name"
                      defaultValue={dataFetching?.data?.data?.periodic?.name}
                      translations={
                        dataFetching?.data?.data?.periodic?.periodicTranslations
                      }
                    />
                  </span>
                </div>
                {renderSearchDetails()?.studyPeriod && (
                  <div className="ver-inf">
                    <span>
                      <FormattedMessage id="study-period" />
                    </span>
                    {/* {renderSearchDetails()?.studyPeriod ? ( */}
                    <span>
                      {GetStudyPeriod(
                        +dataFetching?.data?.data?.yearTypeId,
                        +dataFetching?.data?.data?.periodic?.id,
                        renderSearchDetails()?.studyPeriod
                      )}
                      {/* <LabelLang
                        id="name"
                        defaultValue={renderSearchDetails()?.studyPeriod?.name}
                        translations={
                          renderSearchDetails()?.studyPeriod
                            ?.studyPeriodTranslations
                        }
                      /> */}
                    </span>
                    {/* ) : (
                    <span>
                      <FormattedMessage id="data-not-found" />
                    </span>
                  )} */}
                  </div>
                )}
                {renderSearchDetails()?.releaseDate && (
                  <div className="ver-inf">
                    <span>
                      <FormattedMessage id="issue-date" />
                    </span>
                    <span>
                      {renderSearchDetails()?.releaseDate ? (
                        <DateFormater
                          value={renderSearchDetails()?.releaseDate}
                          type={"monthYear"}
                        />
                      ) : (
                        <FormattedMessage id="data-not-found" />
                      )}
                    </span>
                  </div>
                )}
                {/* <div className="ver-inf">
                  <span>
                    <FormattedMessage id="next-publication-date" />
                  </span>
                  <span>
                    {renderSearchDetails()?.releaseDate ? (
                      <DateFormater
                        value={renderSearchDetails()?.releaseDate}
                        type={"monthYear"}
                      />
                    ) : (
                      <FormattedMessage id="data-not-found" />
                    )}
                  </span>
                </div> */}
                {/*<div className="ver-inf">
                  <span>سعر النسخة الورقية</span>
                  <span>جنيه 20</span>
                </div>*/}
              </div>
              <div
                className="box-ver-i mt-4"
                style={{ height: "300px", overflowY: "auto" }}
              >
                <h6>
                  <FormattedMessage id="related-publications" />
                </h6>
                {relatedDataFetching?.data?.data?.length > 0 ? (
                  <>
                    {relatedDataFetching?.data?.data &&
                      relatedDataFetching?.data?.data?.map(
                        ({ name, id, publicationTranslations }, i) => (
                          <li key={i} className="list-unstyled">
                            <Link to={`/publications/${id}`}>
                              <ChevronIcon width={20} height={10} />{" "}
                              {LabelLangString({
                                id: "name",
                                currentLocale: currentLocale,
                                defaultValue: name,
                                translations: publicationTranslations,
                              })}
                            </Link>
                          </li>
                        )
                      )}
                  </>
                ) : (
                  <DataNotFound />
                )}
                {/* <a href="">
                  <ChevronIcon width={20} height={10} /> متوسط اسعار المستهلك
                  لاهم السلع الغذائية
                </a>
                <br></br>
                <br></br>
                <a href="">
                  <ChevronIcon width={20} height={10} /> الارقام القياسية لاسعار
                  المنتجين
                </a>
                <br></br>
                <br></br>
                <a href="">
                  <ChevronIcon width={20} height={10} /> بحث الدخل و الانفاق
                </a>
                <br></br>
                <br></br>
                <a href="">
                  <ChevronIcon width={20} height={10} /> النشرة المعلوماتية
                </a>
                <br></br>
                <br></br>
                <a href="">
                  <ChevronIcon width={20} height={10} /> الكتاب الاحصائي السنوي
                </a> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="all-vv">
        <SliderVersion />
      </div> */}
    </ContentLoading>
  );
}

export default Versions;
